
import { combineReducers } from 'redux';
import messages from './reducers/msgs-reducer';
import conversations from './reducers/convs-reducer';
import actionDialog from './reducers/action-dialog-reducer';

export default combineReducers({ messages, conversations, actionDialog });





// WEBPACK FOOTER //
// ./src/app/components/messaging/messagingStore/messaging-reducer.js